import {defineMessages} from 'react-intl';

export default defineMessages({
	forgotPassword: {
		id: 'auth.login.restore',
		defaultMessage: 'Forgot your password?',
	},
});
